// Port of api/fuel/app/classes/filter/search/games/sorts/query/rating/group/date.php
import F from 'offline/filter/constants'
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'rating.date',
	post: false,
	require: function(config, filter) {
		return sorted('rating.date', filter) > 0 && config.ownerType !== F.OWNER_USER
	},
	run: function(config, filter, data, query) {
		query.order('MAX(r.rating_date)', sortReverse('rating.date', filter), sortPriority('rating.date', filter))
	}
}
